import { useRef, useState, useCallback } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';

export function BoozenConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  danger = false,
  icon,
}) {
  const cancelRef = useRef();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
      motionPreset="slideInBottom"
    >
      <AlertDialogOverlay backdropFilter="blur(3px)" bg="rgba(0,0,0,0.45)">
        <AlertDialogContent
          borderRadius="20px"
          overflow="hidden"
          mx={4}
          boxShadow="0 24px 64px rgba(0,74,51,.18)"
        >
          <AlertDialogHeader
            bg={danger ? "#c0392b" : "#004a33"}
            py="14px"
            px="20px"
          >
            <Text color="white" fontWeight="900" fontSize="16px">
              {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
              {title || "Confirmar"}
            </Text>
          </AlertDialogHeader>

          <AlertDialogBody py={5} px={5}>
            <Text fontSize="14px" color="gray.600" lineHeight="1.6">
              {description || "Tem certeza que deseja continuar?"}
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter gap={3} px={5} pb={5}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              variant="outline"
              borderColor="rgba(0,74,51,.2)"
              color="#004a33"
              borderRadius="12px"
              size="sm"
              fontWeight="700"
              _hover={{ bg: "rgba(0,74,51,.05)" }}
            >
              {cancelLabel}
            </Button>
            <Button
              onClick={onConfirm}
              bg={danger ? "#c0392b" : "#004a33"}
              color={danger ? "white" : "#fc8f04"}
              borderRadius="12px"
              fontWeight="800"
              size="sm"
              _hover={{ opacity: 0.88 }}
            >
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export function useBoozenConfirm() {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({});
  const resolveRef = useRef(null);

  const confirm = useCallback((options = {}) => {
    setConfig(options);
    setIsOpen(true);
    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    resolveRef.current?.(true);
  }, []);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
    resolveRef.current?.(false);
  }, []);

  const confirmDialogProps = {
    isOpen,
    onClose: handleCancel,
    onConfirm: handleConfirm,
    ...config,
  };

  return { confirm, confirmDialogProps };
}
